import { useMemo } from 'react';

import EventInfoRow from './event-info-row';

import { ORDER_OUTCOME } from '@/constants/solana';
import { useAvgBuyPrice } from '@/hooks/backend/metrics/use-avg-buy-price';

type Props = {
  price: string;
  shares: string;
  id: number;
  averageOrderPrice: number;
  outcome: ORDER_OUTCOME;
};

const EventSellProfitMultiplierRow = ({
  price,
  shares,
  id,
  outcome,
  averageOrderPrice,
}: Props) => {
  const { data: buyPriceRes } = useAvgBuyPrice(
    Number(id),
    outcome === ORDER_OUTCOME.YES ? 'YES' : 'NO',
  );

  const avgBuyPrice = useMemo(() => {
    if (!buyPriceRes) return 0;
    return buyPriceRes.averageBuyPrice;
  }, [buyPriceRes]);

  const profitMultiplier = useMemo(() => {
    if (!price || !shares || !avgBuyPrice) return 0;

    const avgSellPrice = averageOrderPrice || +price;

    return avgSellPrice / avgBuyPrice;
  }, [price, shares, avgBuyPrice, averageOrderPrice]);

  return (
    <EventInfoRow
      title="Multiplier"
      className="text-primary-cta text-[18px] font-medium"
      content={<p>{profitMultiplier.toFixed(2)}x</p>}
    />
  );
};

export default EventSellProfitMultiplierRow;
